import { apiUrl } from "../ApiManager/AxiosHeaders";

function unwrapList(payload) {
  const data = payload?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

export async function fetchAllEmployees() {
  const res = await apiUrl.get("getAllUsers", {
    params: { page: 1, perPage: 0 },
  });
  return unwrapList(res.data);
}

export async function fetchPermissionGroups(perPage = 500) {
  const res = await apiUrl.get("permission-groups", {
    params: { perPage },
  });
  return unwrapList(res.data);
}

export async function createPermissionGroup({ name, description }) {
  const res = await apiUrl.post("permission-groups", { name, description });
  return res.data?.data;
}

export async function updatePermissionGroup(id, { name, description }) {
  const res = await apiUrl.put(`permission-groups/${id}`, {
    name,
    description,
  });
  return res.data?.data;
}

export async function deletePermissionGroup(id) {
  const res = await apiUrl.delete(`permission-groups/${id}`);
  return res.data;
}

export async function fetchPermissionGroupPermissions(groupId) {
  const res = await apiUrl.get(`permission-groups/${groupId}/permissions`);
  return res.data?.data;
}

export async function bulkUpdatePermissionGroupPermissions(groupId, changes) {
  const res = await apiUrl.post(
    `permission-groups/${groupId}/permissions/bulk`,
    { changes },
  );
  return res.data;
}

/** Add or remove one group membership (users may belong to many groups). */
export async function assignUserPermissionGroup(
  userId,
  permissionGroupId,
  member = true,
) {
  const res = await apiUrl.post("assign-permission-group", {
    user_id: userId,
    permission_group_id: permissionGroupId,
    member: !!member,
  });
  return res.data?.data;
}
